import { Fragment } from "react";
import { DataGrid } from "@mui/x-data-grid";
import { RenderCellExpand } from "../../../../../../../shared/components";
import { Typography } from "@material-ui/core";
import useStyles from "./styles";

export const FailedTableInfo = ({ rows }) => {
  const classes = useStyles();

  const columns = [
    {
      field: "nombre",
      headerName: "Nombre",
      flex: 1,
      headerClassName: "header",
      headerAlign: "center",
    },
    {
      field: "error",
      headerName: "Error",
      flex: 1,
      headerClassName: "header",
      headerAlign: "center",
      renderCell: RenderCellExpand,
    },
  ];

  return (
    <Fragment>
      <Typography color="primary" variant="h6">
        Errores en el archivo
      </Typography>
      <DataGrid
        columns={columns}
        rows={rows ?? []}
        className={classes.root}
        disableSelectionOnClick
        disableColumnMenu
        rowsPerPageOptions={[8]}
        pageSize={8}
        getRowId={(row) => row.nombre}
        pagination
      />
    </Fragment>
  );
};
